<template>
  <div>
    <h4>Add Product</h4>
    <div class="panel-container">
    </div>
  </div>
</template>

<script>
export default {
  props: {
  },
  watch: {
  },
  components: {
  },
  data () {
    return {
      resId: ''
    }
  },
  beforeMount () {
    this.resId = this.$route.params.rid
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style lang="scss">

</style>
